// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./auth.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 로그인 */
.login-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.login-section {
  display: flex;
  flex-direction: column;
  width: 520px;
}

.login-logo {
  margin-bottom: 18px;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 52px;
}

.login-logo>img {
  height: 100%;
  object-fit: contain;
}

.login-account-save {
  margin-top: 20px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 24px;
  gap: 10px;
}

.login-account-save>img {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.login-account-save>span {
  font-size: 17px;
  color: #474A52;
}

.login-account-link {
  margin: 28px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.login-account-link>button {
  font-size: 17px;
  color: #474A52;
  cursor: pointer;
}

.login-account-link>p {
  font-size: 15px;
  color: var(--background-disable-color);
  font-weight: 700;
}

.login-register-link {
  box-sizing: border-box;
  display: flex;
  padding: 16px 32px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 88px;
  border-radius: 8px;
  background-color: #EAE9FC;
  cursor: pointer;
}

.login-register-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: space-between;
  align-items: flex-start;
}

.login-register-text>p {
  font-size: 18px;
  color: #474A52;
}

.login-register-text>span {
  font-size: 18px;
  color: #330891;
  font-family: 'Pretendard Medium', sans-serif;
}

.login-register-logo {
  display: flex;
  width: 56px;
  height: 56px;
}

.login-sso-text {
  margin: 24px 0;
  display: flex;
  align-items: center;
  width: 100%;
}

.login-sso-text>hr {
  width: calc(50% - 50px);
  height: 2px;
  background-color: var(--background-disable-color);
  border: none;
  margin: 0;
}

.login-sso-text>span {
  display: flex;
  justify-content: center;
  width: 100px;
  height: 100%;
  font-size: 17px;
  color: #595D6C;
}


.login-sso-box {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.login-sso-item {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 60px;
  padding: 14px 24px;
  align-items: center;
  background-color: white;
  border-radius: 100px;
  cursor: pointer;
}

.login-sso-logo {
  width: 32px;
  height: 32px;
}

.login-sso-logo>img {
  width: 100%;
  object-fit: contain;
}

.login-sso-logo-text {
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 40px);
  height: 32px;
  line-height: 160%;
  font-size: 18px;
  font-family: 'Pretendard Medium', sans-serif;
  color: var(--text-black-color);
}


/* 온보딩 UI */
.onBoarding-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.onBoarding-total-box {
  position: relative;
  display: flex;
  gap: 60px;
  width: 1200px;
  height: 565px;
}

.onBoarding-arrow {
  position: absolute;
  top: 50%;
  z-index: 5;
  width: 48px;
  height: 48px;
  cursor: pointer;
}

.onBoarding-arrow.disable {
  cursor: not-allowed;
}

.onBoarding-arrow.previous {
  left: -80px;
}

.onBoarding-arrow.next {
  right: 10px;
}

.onBoarding-arrow>img {
  width: 100%;
  height: 100%;
}

.onBoarding-img-box {
  width: 850px;
  height: 565px;
}

.onBoarding-img-box-content {
  position: relative;
  display: flex;
  gap: 60px;
  width: 850px;
  height: 565px;
}

.onBoarding-img-box-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 850px;
  height: 100%;
  background: #E7EAEF;
  border-radius: 10px;
}

.onBoarding-img-box-inner>img {
  width: 100%;
  max-width: 750px;
  object-fit: contain;
}

.onBoarding-text-box {
  margin-top: 200px;
  width: 290px;
  height: 300px;
}

.onBoarding-text-box>span {
  font-size: 36px;
  font-family: "Pretendard SemiBold", sans-serif;
  line-height: 120%;
  color: #201E24;
  white-space: pre-wrap;
}

.onBoarding-text-box>p {
  margin: 20px 0 30px 0;
  font-size: 18px;
  line-height: 150%;
  color: #474A52;
  white-space: pre-wrap;
}

.onBoarding-text-box>button {
  width: 232px;
  height: 64px;
  border-radius: 8px;
  background: #3E0BB7;
  color: white;
  font-size: 18px;
  font-family: "Pretendard Medium", sans-serif;
  cursor: pointer;
}

.dots_custom {
  display: inline-block;
  vertical-align: middle;
  margin: auto 0;
  padding: 0;
}

.dots_custom li {
  list-style: none;
  cursor: pointer;
  display: inline-block;
  margin: 0 3px;
  padding: 0;
}

.dots_custom li button {
  border: none;
  background: #d1d1d1;
  color: transparent;
  cursor: pointer;
  display: block;
  height: 12px;
  width: 12px;
  border-radius: 100%;
  padding: 0;
}

.dots_custom li.slick-active button {
  background-color: #3E0BB7;
}

.onBoarding-img-box .slick-slider .slick-arrow {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/service/auth/login.css"],"names":[],"mappings":"AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,iDAAiD;EACjD,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;AAChC;;;AAGA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["@import \"auth.css\";\n\n/* 로그인 */\n.login-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.login-section {\n  display: flex;\n  flex-direction: column;\n  width: 520px;\n}\n\n.login-logo {\n  margin-bottom: 18px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 52px;\n}\n\n.login-logo>img {\n  height: 100%;\n  object-fit: contain;\n}\n\n.login-account-save {\n  margin-top: 20px;\n  margin-bottom: 32px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 24px;\n  gap: 10px;\n}\n\n.login-account-save>img {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n}\n\n.login-account-save>span {\n  font-size: 17px;\n  color: #474A52;\n}\n\n.login-account-link {\n  margin: 28px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n\n.login-account-link>button {\n  font-size: 17px;\n  color: #474A52;\n  cursor: pointer;\n}\n\n.login-account-link>p {\n  font-size: 15px;\n  color: var(--background-disable-color);\n  font-weight: 700;\n}\n\n.login-register-link {\n  box-sizing: border-box;\n  display: flex;\n  padding: 16px 32px;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 88px;\n  border-radius: 8px;\n  background-color: #EAE9FC;\n  cursor: pointer;\n}\n\n.login-register-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.login-register-text>p {\n  font-size: 18px;\n  color: #474A52;\n}\n\n.login-register-text>span {\n  font-size: 18px;\n  color: #330891;\n  font-family: 'Pretendard Medium', sans-serif;\n}\n\n.login-register-logo {\n  display: flex;\n  width: 56px;\n  height: 56px;\n}\n\n.login-sso-text {\n  margin: 24px 0;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.login-sso-text>hr {\n  width: calc(50% - 50px);\n  height: 2px;\n  background-color: var(--background-disable-color);\n  border: none;\n  margin: 0;\n}\n\n.login-sso-text>span {\n  display: flex;\n  justify-content: center;\n  width: 100px;\n  height: 100%;\n  font-size: 17px;\n  color: #595D6C;\n}\n\n\n.login-sso-box {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.login-sso-item {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  height: 60px;\n  padding: 14px 24px;\n  align-items: center;\n  background-color: white;\n  border-radius: 100px;\n  cursor: pointer;\n}\n\n.login-sso-logo {\n  width: 32px;\n  height: 32px;\n}\n\n.login-sso-logo>img {\n  width: 100%;\n  object-fit: contain;\n}\n\n.login-sso-logo-text {\n  margin-left: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 40px);\n  height: 32px;\n  line-height: 160%;\n  font-size: 18px;\n  font-family: 'Pretendard Medium', sans-serif;\n  color: var(--text-black-color);\n}\n\n\n/* 온보딩 UI */\n.onBoarding-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.onBoarding-total-box {\n  position: relative;\n  display: flex;\n  gap: 60px;\n  width: 1200px;\n  height: 565px;\n}\n\n.onBoarding-arrow {\n  position: absolute;\n  top: 50%;\n  z-index: 5;\n  width: 48px;\n  height: 48px;\n  cursor: pointer;\n}\n\n.onBoarding-arrow.disable {\n  cursor: not-allowed;\n}\n\n.onBoarding-arrow.previous {\n  left: -80px;\n}\n\n.onBoarding-arrow.next {\n  right: 10px;\n}\n\n.onBoarding-arrow>img {\n  width: 100%;\n  height: 100%;\n}\n\n.onBoarding-img-box {\n  width: 850px;\n  height: 565px;\n}\n\n.onBoarding-img-box-content {\n  position: relative;\n  display: flex;\n  gap: 60px;\n  width: 850px;\n  height: 565px;\n}\n\n.onBoarding-img-box-inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 850px;\n  height: 100%;\n  background: #E7EAEF;\n  border-radius: 10px;\n}\n\n.onBoarding-img-box-inner>img {\n  width: 100%;\n  max-width: 750px;\n  object-fit: contain;\n}\n\n.onBoarding-text-box {\n  margin-top: 200px;\n  width: 290px;\n  height: 300px;\n}\n\n.onBoarding-text-box>span {\n  font-size: 36px;\n  font-family: \"Pretendard SemiBold\", sans-serif;\n  line-height: 120%;\n  color: #201E24;\n  white-space: pre-wrap;\n}\n\n.onBoarding-text-box>p {\n  margin: 20px 0 30px 0;\n  font-size: 18px;\n  line-height: 150%;\n  color: #474A52;\n  white-space: pre-wrap;\n}\n\n.onBoarding-text-box>button {\n  width: 232px;\n  height: 64px;\n  border-radius: 8px;\n  background: #3E0BB7;\n  color: white;\n  font-size: 18px;\n  font-family: \"Pretendard Medium\", sans-serif;\n  cursor: pointer;\n}\n\n.dots_custom {\n  display: inline-block;\n  vertical-align: middle;\n  margin: auto 0;\n  padding: 0;\n}\n\n.dots_custom li {\n  list-style: none;\n  cursor: pointer;\n  display: inline-block;\n  margin: 0 3px;\n  padding: 0;\n}\n\n.dots_custom li button {\n  border: none;\n  background: #d1d1d1;\n  color: transparent;\n  cursor: pointer;\n  display: block;\n  height: 12px;\n  width: 12px;\n  border-radius: 100%;\n  padding: 0;\n}\n\n.dots_custom li.slick-active button {\n  background-color: #3E0BB7;\n}\n\n.onBoarding-img-box .slick-slider .slick-arrow {\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
